/** Status pretendidos das análises de mercados de clientes */
export interface ClienteAnaliseMercadoStatusPretendido {
    id: number;
    nome: string;
}

export const statusPretendidoNaoPretendido: ClienteAnaliseMercadoStatusPretendido = {
    id: 1,
    nome: 'Não Pretendido'
};
export const statusPretendidoPretendido: ClienteAnaliseMercadoStatusPretendido = {
    id: 2,
    nome: 'Pretendido'
};
export const statusPretendidoPotencial: ClienteAnaliseMercadoStatusPretendido = {
    id: 3,
    nome: 'Sell In Cliente'
};

export const statusPretendidoRealizado: ClienteAnaliseMercadoStatusPretendido = {
    id: 4,
    nome: 'Realizado'
};

export const statusPretendidos: ClienteAnaliseMercadoStatusPretendido[] = [
    statusPretendidoNaoPretendido,
    statusPretendidoPretendido,
    statusPretendidoPotencial,
    statusPretendidoRealizado
];


/** Verifica se o status pretendido é igual a Não Pretendido */
export function isStatusPretendidoNaoPretendido(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusPretendidoNaoPretendido.id;
}

/** Verifica se o status pretendido é igual a Pretendido */
export function isStatusPretendidoPretendido(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusPretendidoPretendido.id;
}

/** Verifica se o status pretendido é igual a Potencial */
export function isStatusPretendidoPotencial(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusPretendidoPotencial.id;
}


/** Verifica se o status pretendido é igual a Realizado */
export function isStatusPretendidoRealizado(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === statusPretendidoRealizado.id;
}
